var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUeberhoehungOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Ueberhoehung_ON__Icn/40px/Ueberhoehung_ON",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: ".._.._src_svg_Icn_40px_Ueberhoehung_ON__Color/20px/Platzhalter-Transparent",
    fillRule: "nonzero",
    opacity: 0
  }, /*#__PURE__*/React.createElement("path", {
    id: ".._.._src_svg_Icn_40px_Ueberhoehung_ON__Rectangle",
    d: "M0 0H40V40H0z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M23.357066,9.11744336 L34.5029869,28 L4.81970367,28 L14.893444,15.4993386 L17.492,18.702 L23.357066,9.11744336 Z M23.3264114,13 L18.8347037,20.3424434 L20.7845502,22.8095612 L19.2154498,24.0496917 L17.6607037,22.0824434 L14.8989473,18.6799044 L9,26 L31,26 L23.3264114,13 Z",
    id: ".._.._src_svg_Icn_40px_Ueberhoehung_ON__Combined-Shape"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUeberhoehungOn);
export default __webpack_public_path__ + "static/media/Ueberhoehung_ON.61ca7960d8deb0f2eb0341fd56b78012.svg";
export { ForwardRef as ReactComponent };